import { Modal, Select } from 'antd'
import React from 'react'

const FilterModal = ({ setOpenFilter, openFilter, getProductsData, setStatus}) => {
  return (
    <Modal
      title="Filter By Status"
      onCancel={() => setOpenFilter(false)}
      open={openFilter}
      footer={false}
    >
      <Select
        size='large'
        placeholder='Select Status'
        onChange={(value)=> {
          setStatus(value)
          setOpenFilter(false)
        }}
        style={{width: "100%"}}
      >
        {getProductsData?.map((e)=>(
          <Select.Option value={e.id}>{e.name}</Select.Option>
        ))}
      </Select>
    </Modal>
  )
}

export default FilterModal